import React, { useState, useEffect } from "react";
import { useAuthContext } from "../../../hooks/useAuthContext";

// style
import "./GeneradorQR.css";

import { Button, Col } from "react-bootstrap";

import { faPrint } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function GeneradorQR() {
  const { register } = useAuthContext();
  const [data, setData] = useState([]);

  useEffect(() => {
    var qrText =
      "https://quickchart.io/qr?text=TA-" + register.id + "-" + register.id;
    var info = {
      nombre: "MENU PLAZA",
      qr: qrText,
    };
    var qrText3 = "https://quickchart.io/qr?text=https://onelink.to/52jvjq";
    var info3 = {
      nombre: "QR APLICACION",
      qr: qrText3,
    };
    setData([info, info3]);
  }, [register]);

  const printQR = () => {
    var content = document.getElementById("project-qr");
    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  };

  return (
    <div className="row">
      <iframe
        title="Frames"
        className="iframePrint"
        id="ifmcontentstoprint"
      ></iframe>
      <br />

      <h4 className="page-title">GENERADOR QR</h4>
      <br />

      <div className="row">
        <div id="project-qr" className="row">
          {data.map((n) => (
            <div className="col-6">
              <div className="center">
                <>
                  <img className="qr-code" src={n.qr} alt="QR"></img>
                  <div className="center">{n.nombre}</div>
                </>
              </div>
            </div>
          ))}
        </div>

        <div className="center">
          <div className="" onClick={printQR}>
            <Button variant="primary" className="button" type="button">
              <FontAwesomeIcon icon={faPrint} /> IMPRIMIR
            </Button>
          </div>
        </div>
      </div>
      <br />
    </div>
  );
}
